import {
  Button,
  Modal,
  ModalActions,
  ModalContent,
  ModalContentText,
  ModalTitle,
  Link,
} from '@deere/fuel-react';
import React from 'react';
import './PopupMandatoryModel.css';

const PopupMandatoryModel = ({title, description, hrefLink, hrefDesc}) => {
  return (
    <Modal
      aria-describedby={'alert-Modal-description'}
      aria-labelledby={'alert-Modal-title'}
      open={true}
      showClose={false}
    >
      <ModalTitle
        bgcolor={'#F0F0F0'}
        id={'alert-Modal-title'}
        className="manpopup manpopuptitle"
      >
        {title}
      </ModalTitle>
      <ModalContent className="manpopup manpopupdesc">
        <ModalContentText id={'alert-Modal-description'} className="manpopup">
          {description}
        </ModalContentText>
      </ModalContent>
      <ModalActions>
        <Button variant={'primary'}>
          <Link href={hrefLink}>{hrefDesc}</Link>
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default PopupMandatoryModel;
